import React from 'react';
import OAuthCallbackPage from './OAuthCallbackPage';

const GithubOAuthCallback: React.FC = () => (
  <OAuthCallbackPage
    provider="github_oauth"
    redirectUri={`${window.location.origin}/auth/github-oauth/callback`}
    loadingText="Connecting to GitHub…"
    successTitle="GitHub Connected!"
    successBody="Your GitHub account has been successfully connected."
  />
);

export default GithubOAuthCallback;
